import React, { useState, useEffect } from 'react'
import Modal from 'live/components/ui/Modal'
import listIntegrationSftp from './api/listIntegrationSftp'
import Select from 'react-select'
import styled from 'styled-components'
import i18n from '../../services/i18n'

import LiveTooltip from 'live/components/ui/tooltip'
import ListEventType from '../ListEventType'
import listTypes from '../../api/listTypes'
import type { Group } from '../groups/interface/Group'
import type SFTP from './interface/sftpIntegration'


const checkTemplates = (sftp: SFTP): boolean => {

    const templates = sftp?.groupModels?.templates;
    if (!templates || templates.length == 0) return false;


    const checkString = (s): boolean => {
        return s != null && s != '' && typeof s == 'string' && s.length > 0
    }
    if (!checkString(sftp.qualifierSFTP)) return false;

    return !templates.some(templates => {
        if (!checkString(templates.matchFileName)) return true;
        if (!checkString(templates.eventType)) return true;
        if (!checkString(templates.matchTabName)) return true;
    })
}

export default function ModalEdition({ sftp, onHide,onSave }: {
    sftp: SFTP
    onHide: () => void
    onSave: (sftp:SFTP) => void
}) {

    const [options, setOptions] = useState([])
    const [types, setTypes] = useState<string[]>([])

    // 
    const [draftSFTP, setDraftSFTP] = useState<SFTP>(sftp)

    useEffect(() => {
        setDraftSFTP(sftp)
    }, [sftp?.qualifierSFTP])

    const updateTemplate = (template: Group, index: number) => {
        const aux = { ...draftSFTP }
        aux.groupModels.templates[index] = template
        setDraftSFTP(aux)
    }

    const removeTemplate = (index: number) => {
        const aux = { ...draftSFTP }
        delete aux.groupModels.templates[index]
        setDraftSFTP(aux)
    }

    const getEventText = ({ target }) => {
        const value = target?.value
        if (!!value) return value
        return ''
    }


    useEffect(() => {
        listIntegrationSftp().then(newOptions => setOptions(newOptions))
        listTypes().then(newtypes => setTypes(newtypes))
    }, [])

    return <Modal show={!!sftp} keyboard={false} onHide={() => onHide()} className="newGroupDatabaseModal">
        <Modal.Header>
            <Modal.Title>
                <b>{!!sftp?.uid ? 'Edit' : 'Create'} SFTP</b>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>

            <FormGroup>
                <label>SFTP</label>
                <Select key={"qualifier-sftp"} value={{
                    label: draftSFTP?.qualifierSFTP,
                    value: draftSFTP?.idSFTP,
                }} options={options.map(option => ({ value: option.id, label: option.qualifier }))}
                    onChange={({ value, label }) => {
                        if (!!value && !!label) {
                            setDraftSFTP((currSftp) => ({
                                ...currSftp,
                                idSFTP: Number(value),
                                qualifierSFTP: label
                            }))
                        }
                    }}
                />

            </FormGroup>

            <Table>
                <thead>
                    <tr>
                        <th>
                            Database
                        </th>
                        <th>
                            <span>File Name</span>
                            <LiveTooltip
                                className="table--column__live-tooltip"
                                hide={false}
                                position="top"
                                content={i18n('RegEx Example: First_Characters_*')}
                            >
                                <Icon color="#37A3EF" className="far fa-info-circle" />
                            </LiveTooltip>{' '}
                        </th>
                        <th>
                            <span>
                                <b>Tab </b>
                                {'(index or ID)'}
                            </span>
                            <LiveTooltip
                                className="table--column__live-tooltip"
                                hide={false}
                                position="top"
                                content={i18n('Insert Sheet tab name or sheet id.')}
                            >
                                <Icon color="#37A3EF" className="far fa-info-circle" />
                            </LiveTooltip>
                        </th>
                        <th>
                            <b>Reference Date</b>
                            <LiveTooltip
                                className="table--column__live-tooltip"
                                hide={false}
                                position="top"
                                content={i18n('Format: dd/mm/AAAA.')}
                            >
                                <Icon color="#37A3EF" className="far fa-info-circle" />
                            </LiveTooltip>{' '}
                        </th>
                        <th>
                            {/* ACTIONS */}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        draftSFTP?.groupModels?.templates.map((template, index) => {
                            return <tr key={'template-' + index}>
                                <td>
                                    <FormGroup>
                                        <div style={{margin: "5px 0px"}}>
                                            <ListEventType value={template?.eventType}
                                                onChange={value => updateTemplate({
                                                    ...template,
                                                    eventType: value
                                                }, index)} defaultOptions={types} />
                                        </div>
                                    </FormGroup>
                                </td>
                                <td>
                                    <FormGroup>
                                        <input type={"text"} value={template?.matchFileName}
                                            onChange={ev => updateTemplate({
                                                ...template,
                                                matchFileName: getEventText(ev)
                                            }, index)} />
                                    </FormGroup>
                                </td>
                                <td>
                                    <FormGroup>
                                        <input type={"text"} value={template?.matchTabName}
                                            onChange={ev => updateTemplate({
                                                ...template,
                                                matchTabName: getEventText(ev)
                                            }, index)} />
                                    </FormGroup>
                                </td>
                                <td>
                                    <FormGroup>
                                        <input type={"text"} disabled={true} value={template?.refDate} />
                                    </FormGroup>
                                </td>
                                <td>
                                    {
                                        index ? <LiveTooltip
                                            className="table--column__live-tooltip"
                                            hide={false}
                                            position="top"
                                            content={i18n('Delete integration')}
                                        >
                                            <Icon color="#d9534f" className="far fa-trash-alt" onClick={event => {
                                                removeTemplate(index)
                                            }} />
                                        </LiveTooltip> : null
                                    }

                                </td>
                            </tr>
                        })
                    }
                </tbody>
            </Table>
            <AddButton onClick={() => {
                updateTemplate({
                    databaseName: '',
                    matchFileName: '',
                    matchTabName: '',
                    refDate: '',
                    eventType: ''
                }, sftp.groupModels.templates.length)
            }}> ADD DATABASE</AddButton>

        </Modal.Body>
        <Modal.Footer>
            <FooterContainer>
                <button className="btn btn-primary"
                    disabled={!checkTemplates(draftSFTP)}
                    onClick={event => {
                        onSave(draftSFTP)
                        onHide()
                    }}>
                    Save
                </button>

                <button className="cancel btn btn-secudary" onClick={() => onHide()}>
                    <div>Cancel</div>
                </button>
            </FooterContainer>
        </Modal.Footer>
    </Modal>
}
const FormGroup = styled.div`
 width:250px;   
`
const Table = styled.table`
    width:100%;
    th > * {
        margin-right: 5px;
    }
`;

const AddButton = styled.button`
    margin-top: 10px;
    width: 100%;
    border: none;
    color: var(--blue-500);
    background: var(--blue-200);    
    font-size: 14px;   
    padding: 5px; 
`

const FooterContainer = styled.div`    
    .delete {
        background: var(--red-700);
        border-radius: 3px;
        margin-right: 4px;
        border: none;
        color: white;
        width: 79px;
        height: 32px;
    }
    .cancel {
        color: var(--static-gray-0);
        background: var(--static-gray-600);
        text-decoration: none;
    }

`

const Icon = styled.i`
    font-family: Font Awesome 5 Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 40px;
    color: ${props => props.color};
    margin-right: 1rem;
`